// extracted by mini-css-extract-plugin
module.exports = {"instagram":"about-nav_instagram_6rkPh","component":"about-nav_component_3VF3h","list":"about-nav_list_i5AML","is-active":"about-nav_is-active_1xwhW"};